import { getMktSegIdFromMappedMktSegId } from "../../utils/global_functions";
import { BUSINESS_LAYER_RESPONSE, WATCHLIST_GRID_INDEX } from "../../utils/global_variables";



async function _getDontMiss(arrWatchlists, arrWhatsHotData, objRecommendationsData) {
    try {
        let resultObject = {};
        const dontMiss = [];
        const arrRecommendationScrips = objRecommendationsData?.arrRecommendationScrips;
        const arrRecommendationInfo = objRecommendationsData?.arrRecommendationInfo;

        if (arrWhatsHotData?.length > 0) {
            let chunk = arrWhatsHotData;
            let left = 0;
            let right = chunk?.length - 1;
            while (left <= right) {
                if (resultObject[chunk[left]?.mktid + '_' + chunk[left]?.token]) {
                    let { class: class1, class2, event, date, Desc } = chunk[left];
                    const arrHotList = resultObject[chunk[left]?.mktid + '_' + chunk[left]?.token];
                    arrHotList.push({ color: class1, bg_color: class2, event, date, Desc });
                    resultObject[getMktSegIdFromMappedMktSegId(chunk[left]?.mktid) + '_' + chunk[left]?.token] = arrHotList; //getMktSegIdFromMappedMktSegId
                } else {
                    let { class: class1, class2, event, date, Desc } = chunk[left];
                    resultObject[getMktSegIdFromMappedMktSegId(chunk[left]?.mktid) + '_' + chunk[left]?.token] = [{ color: class1, bg_color: class2, event, date, Desc }]; //getMktSegIdFromMappedMktSegId
                }

                if (left !== right) {
                    if (resultObject[chunk[right]?.mktid + '_' + chunk[right]?.token]) {
                        let { class: class1, class2, event, date, Desc } = chunk[right];
                        const arrHotList = resultObject[chunk[right]?.mktid + '_' + chunk[right]?.token];
                        arrHotList.push({ color: class1, bg_color: class2, event, date, Desc });
                        resultObject[getMktSegIdFromMappedMktSegId(chunk[right]?.mktid) + '_' + chunk[right]?.token] = arrHotList; //getMktSegIdFromMappedMktSegId
                    } else {
                        let { class: class1, class2, event, date, Desc } = chunk[right];
                        resultObject[getMktSegIdFromMappedMktSegId(chunk[right]?.mktid) + '_' + chunk[right]?.token] = [{ color: class1, bg_color: class2, event, date, Desc }]; //getMktSegIdFromMappedMktSegId
                    }

                }
                //moving pointers
                left++;
                right--;
            }
        }


        arrRecommendationScrips?.forEach((recomScrip) => {
            let arrRecomScrip = recomScrip;
            // let nIndex = dontMiss?.findIndex((eachDontMissScrip) => eachDontMissScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === recomScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
            let nRecomIndex = arrRecommendationInfo?.findIndex((recom) => recom?.nMarketSegmentId + '_' + recom?.nToken === recomScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
            //Vaibhav Singh : BT-109089: 27-11-23: Scrip Overview: Changes in Reco chip updated -Start
            if (resultObject[arrRecomScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]]) {
                arrRecomScrip[WATCHLIST_GRID_INDEX.DONT_MISS] = [{ event: 'RECO', bg_color: 'default-chip', buySell: arrRecommendationInfo[nRecomIndex]?.nBuySell, Desc: 'Recommendation' }, ...resultObject[arrRecomScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]]];
                arrRecomScrip[WATCHLIST_GRID_INDEX.DONT_MISS_WATCHLISTS] = [];
            } else {
                arrRecomScrip[WATCHLIST_GRID_INDEX.DONT_MISS] = [{ event: 'RECO', bg_color: 'default-chip', buySell: arrRecommendationInfo[nRecomIndex]?.nBuySell, Desc: 'Recommendation' }];
                arrRecomScrip[WATCHLIST_GRID_INDEX.DONT_MISS_WATCHLISTS] = [];
            }
            dontMiss.push(arrRecomScrip);
            //Vaibhav Singh : BT-109089: 27-11-23: Scrip Overview: Changes in Reco chip updated - End
        }
        );


        // Loop through arrWatchlists and scrips to build dontMiss array

        for (let i = 0; i < arrWatchlists?.length; i++) {
            let { sWatchListName, scrips } = arrWatchlists[i];
            for (let index = 0; index < scrips.length; index++) {
                let scrip = scrips[index];

                if (resultObject[scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]]) {
                    let arrDontMissScrip = scrip;
                    arrDontMissScrip = [
                        ...scrip,
                    ];
                    arrDontMissScrip[WATCHLIST_GRID_INDEX.DONT_MISS] = resultObject[scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]];
                    arrDontMissScrip[WATCHLIST_GRID_INDEX.DONT_MISS_WATCHLISTS] = [sWatchListName];
                    if (!dontMiss.some(each => each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])) { // Avoid Duplicate Scrips
                        dontMiss.push(JSON.parse(JSON.stringify(arrDontMissScrip)));
                    } else {
                        const nIndexOfDontMiss = dontMiss?.findIndex((item) => item[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
                        dontMiss[nIndexOfDontMiss][WATCHLIST_GRID_INDEX.DONT_MISS_WATCHLISTS]?.push(sWatchListName);
                    }
                    scrips[index] = JSON.parse(JSON.stringify(arrDontMissScrip));
                } else if (arrRecommendationScrips?.some(item => item[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])) {
                    const recomScrip = arrRecommendationScrips?.find(item => item[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
                    let nIndex = dontMiss?.findIndex((eachDontMissScrip) => eachDontMissScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === recomScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
                    if (nIndex >= 0) {
                        dontMiss[nIndex][WATCHLIST_GRID_INDEX.DONT_MISS_WATCHLISTS]?.push(sWatchListName);
                    } else { }
                } else { }
            }

        }
        const arrUpdateWatchlistsAfterDontMiss = JSON.parse(JSON.stringify(arrWatchlists));

        return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { allDontMissScrips: dontMiss, arrUpdateWatchlistsAfterDontMiss, resultObject: resultObject } };

    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error };
    }
}

export { _getDontMiss };
